export const validateEmail = (email: string) =>
  email
    ?.toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );

export const validatePassword = (pass: string) => pass && pass.length >= 8 && pass.length <= 400;

export const validateUsername = (username: string) =>
  username.length >= 3 && /^[a-zA-Z0-9)(/_]*$/.test(username);

export const validatePhone = (phone: string) => {
  const phoneRegex =
    /^\+?[0-9]{1,4}?[-.\s]?(\([0-9]{1,4}\)[-.\s]?)?[0-9]{1,4}[-.\s]?[0-9]{1,4}[-.\s]?[0-9]{1,9}$/;
  return phone ? phoneRegex.test(phone) : true;
};
